import React from 'react'
import { motion } from 'framer-motion'
import classnames from 'classnames'

const animatedFadeIn = {
  variants: {
    hidden: { opacity: 0, y: 15 },
    visible: { opacity: 1, y: 0 },
  },
  initial: 'hidden',
  animate: 'visible',
  exit: 'hidden',
  transition: { duration: 0.6, ease: 'easeInOut' },
}

const MotionContainer = ({ children, className }) => (
  <motion.article className={classnames('w-full', className)} {...animatedFadeIn}>
    {children}
  </motion.article>
)
export default MotionContainer
